/**
 * recent-searches.js — Shared recent-search localStorage helpers.
 * Used by homepage-search.js and dawn--prices-page.js.
 * Works in both browser (window.RecentSearches) and Node.js (module.exports).
 */
(function(exports) {
  'use strict';

  var RECENT_KEY = 'inutrition_recent_searches';
  var MAX_RECENT = 5;

  function getRecentSearches() {
    try {
      var data = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(data) ? data.slice(0, MAX_RECENT) : [];
    } catch (e) { return []; }
  }

  function saveRecentSearch(query) {
    if (!query || !query.trim()) return;
    var q = query.trim();
    var recent = getRecentSearches().filter(function(r) { return r !== q; });
    recent.unshift(q);
    if (recent.length > MAX_RECENT) recent = recent.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(recent)); } catch(e) {}
  }

  function removeRecentSearch(query) {
    var recent = getRecentSearches().filter(function(r) { return r !== query; });
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(recent)); } catch(e) {}
  }

  function clearRecentSearches() {
    try { localStorage.removeItem(RECENT_KEY); } catch(e) {}
  }

  exports.RECENT_KEY = RECENT_KEY;
  exports.MAX_RECENT = MAX_RECENT;
  exports.getRecentSearches = getRecentSearches;
  exports.saveRecentSearch = saveRecentSearch;
  exports.removeRecentSearch = removeRecentSearch;
  exports.clearRecentSearches = clearRecentSearches;

})(typeof module !== 'undefined' && module.exports ? module.exports : (window.RecentSearches = {}));
